// LLM が UTF-8 マルチバイト列の組み立てに失敗すると
// `<0xE3><0x80><0x80>` のような生バイトトークン文字列として漏れることがある。
// 連続する run を UTF-8 として復号できれば元の文字に戻し、復号不能なら破棄する。
//
// Qwen3 / DeepSeek 系の推論モデルは <think>...</think> ブロックで思考過程を漏らす。
// これも表示前に丸ごと剥がす。開いたまま閉じない場合は末尾まで、閉じタグだけ来た場合
// はその閉じタグ以前を全て破棄する (先頭に思考の終わりが残る典型パターン)。

const BYTE_TOKEN_RUN = /(?:<0x[0-9A-Fa-f]{2}>)+/g;
const BYTE_TOKEN = /<0x([0-9A-Fa-f]{2})>/g;
const THINK_BLOCK = /<think>[\s\S]*?<\/think>/gi;
const OPEN_THINK_ONLY = /<think>[\s\S]*$/i;
const CLOSE_THINK_HEAD = /^[\s\S]*?<\/think>/i;

function stripThink(text: string): string {
  if (!text.toLowerCase().includes('<think')) {
    // Only closing tag present — drop everything up to and including it
    if (text.toLowerCase().includes('</think>')) {
      return text.replace(CLOSE_THINK_HEAD, '').trimStart();
    }
    return text;
  }
  let out = text.replace(THINK_BLOCK, '');
  // Leftover unclosed <think> — drop from the tag to the end
  if (/<think>/i.test(out)) out = out.replace(OPEN_THINK_ONLY, '');
  // Leftover stray </think> at the head
  if (/^[\s\S]*?<\/think>/i.test(out) && /<\/think>/i.test(out)) {
    out = out.replace(CLOSE_THINK_HEAD, '');
  }
  return out.trimStart();
}

export function sanitizeAiText(text: string): string {
  if (!text) return text;
  let out = text;
  if (out.includes('<0x')) {
    out = out.replace(BYTE_TOKEN_RUN, (run) => {
      const bytes = Array.from(run.matchAll(BYTE_TOKEN), (m) => parseInt(m[1], 16));
      try {
        return new TextDecoder('utf-8', { fatal: true }).decode(new Uint8Array(bytes));
      } catch {
        return '';
      }
    });
  }
  if (/<\/?think>/i.test(out)) {
    out = stripThink(out).trimEnd();
  }
  return out;
}
